import React from 'react'
import { Pagination, Autoplay } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/autoplay'
import { useLangContext } from '../../context/lang.context'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import Headline from '../../components/Headline'
import LinkedinIcon from '../../assets/linkedinIcon'
import { s } from '../../style'

const ProductTeam = ({team, title, isContact}) => {
  const { lang } = useLangContext()

  const content = {
    title: {
      pl: 'Zamówienie zrealizuje dla Ciebie',
      en: '',
    },
    desc: {
      pl: `Poznaj naszych ekspertów.`,
      en: ``,
    },
  }
  
  // const contentContact = {
  //   title: {
  //     pl: 'Zamówienie zrealizuje dla Ciebie',
  //     en: '',
  //   },
  //   desc: {
  //     pl: `Poznaj naszych ekspertów.`,
  //     en: ``,
  //   },
  // }
  
  return (
    <>
      <section css={[sSectionWrapper, isContact && sSectionContactWrapper]}>
        <Headline
          h={2}
          title={!title ? content.title[lang] : title}
          desc={!title ? content.desc[lang] : ''}
          large
          gradient
        />
        <div css={teamWrapper}>
          <Swiper
            // install Swiper modules
            modules={[Pagination, Autoplay]}
            spaceBetween={50}
            slidesPerView={1}
            slidesPerGroup={1}
            autoplay={{delay: 5000}}
            pagination={{ enabled: true, clickable: true }}
            breakpoints={{
              599: {
                slidesPerView: 2,
                slidesPerGroup: 1,
                pagination: {
                  enabled: true,
                },
              },
              1024: {
                slidesPerView: 2,
                slidesPerGroup: 1,
                pagination: {
                  enabled: true,
                },
              },
            }}
            // css={[productRelatedProducts]}
            style={{
              '--swiper-pagination-color': '#20214f',
            }}>
              {team.map((item, index) => (
                <SwiperSlide key={index}>
                  <div css={teamMemberWrapper} key={index}>
                    <div css={teamMemberImageWrapper}>
                      <GatsbyImage
                        objectFit='cover'
                        alt={item.teamMemberName}
                        image={getImage(item.teamMemberImage.gatsbyImageData)}
                      />
                      <div css={sDimmer}></div>
                      <div css={teamMemberName}>
                        {item.teamMemberName}
                        {item.teamMemberPosition && (
                          <span css={[sSubtitle, { fontSize: '1rem' }]}>{item.teamMemberPosition}</span>
                        )}
                      </div>
                    </div>
                    <div css={teamMemberContentWrapper}>
                      {item.teamMemberBio && (
                        <div dangerouslySetInnerHTML={{ __html: item.teamMemberBio.childMarkdownRemark.html }} />
                      )}
                      {(item.teamMemberPhone || item.teamMemberEmail) && (
                        <div css={teamMemberLinks}>
                          {item.teamMemberEmail && (
                            <p>e-mail: <a href={`mailto:` + item.teamMemberEmail}>{item.teamMemberEmail}</a></p>
                          )}
                          {item.teamMemberPhone && (
                            <p>tel: <a href={`tel:` + item.teamMemberPhone}>{item.teamMemberPhone}</a></p>
                          )}
                        </div>
                      )}
                      {item.teamMemberLinkedIn && (
                        <a css={teamMemberLinkedIn} href={item.teamMemberLinkedIn}><LinkedinIcon /></a>
                      )}
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
        </div>
      </section>
    </>
  )
}

const sSectionWrapper = {
  maxWidth: 1500,
  margin: '0 auto',
  padding: '3rem 4rem',
  [s.md_1024]: {
    padding: '0 1rem 3rem',
  }
}

const sSectionContactWrapper = {
  padding: '5rem 4rem 3rem',
  [s.md_1024]: {
    padding: '4rem 1rem 3rem',
  }
}

const teamWrapper = {
  marginTop: '2rem',
  width: '100%',
}

const teamMemberWrapper = {
  width: '100%',
  minHeight: '25rem',
  background: 'linear-gradient(180deg, #2A2C69 0%, #222354 47.46%, #2A2C69 100%)',
  borderRadius: '20px',
  overflow: 'hidden',
  color: 'white',
  display: 'flex',
  [s.lg_down]: {
    flexDirection: 'column',
  }
}

const teamMemberImageWrapper = {
  position: 'relative',
  maxWidth: 300,
  width: '100%',
  minHeight: '25rem',
  borderRadius: '20px',
  overflow: 'hidden',
  'div, img': {
    position: 'absolute',
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    objectPosition: 'top center',
  },
  [s.lg_down]: {
    maxWidth: 'unset',
    minHeight: 'unset',
    height: 0,
    paddingBottom: '100%',
  }
}

const sDimmer = {
  borderRadius: 'inherit',
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  background: `linear-gradient(0deg, rgba(32,32,32,1) 0%, rgba(32,32,32,0) 100%);`,
  transition: 'opacity 0.2s ease-in-out',
}

const teamMemberName = {
  fontWeight: 700,
  letterSpacing: '-0.05em',
  position: 'relative',
  top: 0,
  left: 0,
  zIndex: 2,
  transition: 'all 0.2s ease-in-out',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-end',
  textAlign: 'center',
  paddingBottom: '2rem',
  fontSize: '1.15rem'
}

const sSubtitle = {
  // textTransform: 'uppercase',
  opacity: 0.6,
  fontSize: '1rem',
  // letterSpacing: '0.05em',
  textAlign: 'center',
  fontWeight: 700,
  marginTop: '0.25rem',
  transition: 'all 0.2s ease-in-out',
}

const teamMemberContentWrapper = {
  width: '100%',
  padding: '2rem',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  gap: '30px',
  [s.lg_down]: {
    padding: '2rem 1.25rem',
  },
  [s.sss]: {
    fontSize: '0.85rem'
  }
}

const teamMemberLinkedIn = {
  width: 26,
  height: 'auto',
  transition: 'opacity .3s ease-in-out',
  '&:hover': {
    opacity: 0.6,
  }
}

const teamMemberLinks = {
  'a:hover': {
    textDecoration: 'underline',
  } 
}

export default ProductTeam